module.exports = __webpack_public_path__ + "static/media/pendingOrder.7b381383.svg";